import { render, staticRenderFns } from "./spider.vue?vue&type=template&id=38dac2fc&scoped=true"
import script from "./spider.vue?vue&type=script&lang=js"
export * from "./spider.vue?vue&type=script&lang=js"
import style0 from "./spider.vue?vue&type=style&index=0&id=38dac2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dac2fc",
  null
  
)

export default component.exports